export default "__VITE_ASSET__BOkhv$Xj__"